<h3 mat-dialog-title>{{ this.data.title }}</h3>
<div fxLayout="column" fxLayoutGap="5pt">
  <span [innerHTML]="this.data.message"></span>
  <span *ngIf="data.description">{{ this.data.description }}</span>
  <br>
  <span class="text-red" *ngIf="data.note">
    <b>{{ this.data.note }}</b>
  </span>
</div>
<br>
<div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16pt">
  <button fxFlex="160px" mat-flat-button type="button" [mat-dialog-close]="false" class="form-button-cancel orange">
    <mat-icon class="material-icons-outlined">cancel</mat-icon>
    No
  </button>
  <button fxFlex="160px" mat-flat-button color="accent" type="button" [mat-dialog-close]="true" class="form-button-save">
    <mat-icon class="material-icons-outlined">check_circle</mat-icon>
    Yes
  </button>
</div>
